import { CookieOutlined } from '@mui/icons-material';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCookieConsentControl } from '../../../modules/cookie-consent/useCookieConsent';

export const UserCookieSettings = () => {
  const { show } = useCookieConsentControl();
  const { t } = useTranslation();
  return (
    <Paper sx={{ p: 4, minWidth: '30%', flexShrink: 0 }}>
      <Typography variant={'h6'} mb={2}>
        {t('cookieConsent.title')}
      </Typography>
      <Box mt={4}>
        <Button variant={'outlined'} startIcon={<CookieOutlined />} fullWidth onClick={show}>
          {t('cookieConsent.action')}
        </Button>
      </Box>
    </Paper>
  );
};
